import { render } from "./OnboardingTagPage.vue?vue&type=template&id=1efa36bc"
import script from "./OnboardingTagPage.vue?vue&type=script&lang=js"
export * from "./OnboardingTagPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__